module.exports = __webpack_public_path__ + "media/game-win-2.c16d5a81.wav";